'use client';

import { useEffect, useRef } from 'react';
import Image from 'next/image';
import { RECOGNISED_IN } from '@/content/founder';

export default function RecognisedInMarquee() {
  const trackRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<Animation | null>(null);

  useEffect(() => {
    const el = trackRef.current;
    if (!el || !el.animate) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return;

    animRef.current = el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }], {
      duration: 22000,
      iterations: Infinity,
      easing: 'linear',
    });
    const pause = () => animRef.current?.pause();
    const play = () => animRef.current?.play();
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', play);
    return () => {
      animRef.current?.cancel();
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', play);
    };
  }, []);

  // Duplicated so the 50%-translate loop has a seamless second copy to scroll into.
  const doubled = [...RECOGNISED_IN, ...RECOGNISED_IN];

  return (
    <div
      className="relative overflow-hidden"
      style={{
        WebkitMaskImage: 'linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)',
        maskImage: 'linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)',
      }}
    >
      <div ref={trackRef} className="flex w-max items-center gap-5">
        {doubled.map((outlet, i) => (
          <span
            key={`${outlet.name}-${i}`}
            aria-hidden={i >= RECOGNISED_IN.length}
            className="flex h-[64px] w-[130px] shrink-0 items-center justify-center rounded-[14px] p-3 sm:h-[84px] sm:w-[180px]"
          >
            <Image
              src={outlet.logo}
              alt={outlet.name}
              width={140}
              height={64}
              className="h-full w-full object-contain"
            />
          </span>
        ))}
      </div>
    </div>
  );
}
